<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.categoryId ? (isEdit ? '编辑分类' : '查看分类') : '新增分类'"  v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-show="baseForm.categoryId">
      <el-button v-if="mixinHasPermi(['product:category:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.categoryId)" label-width="120px">
        <el-form-item class="half" label="父级分类" key="parentCategoryId" prop="parentCategoryId">
          <el-cascader aria-hidden="false" disabled :options="categoryData" :props="props"
            v-model="dialogForm.parentCategoryId" clearable placeholder="请选择父级分类" />
        </el-form-item>
        <el-form-item class="half" label="分类名称" key="categoryName" prop="categoryName">
          <el-input v-model.trim="dialogForm.categoryName" clearable :placeholder="`请输入分类名称`" />
        </el-form-item>

        <el-form-item class="all" label="备注" key="remark" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.categoryId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.categoryId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { categoryApi } from "@/api"
export default {
  name: "CategoryDialog",
  props: {
    // 数据
    categoryData: {
      type: Array,
      default: () => {
        return []
      }
    },
    props: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查名称是否已存在 */
    const checkCategoryName = (rule, value, callback) => {
      categoryApi
        .judgeCategoryNameExist({ categoryName: value, categoryId: this.dialogForm.categoryId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }

    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        parentCategoryId: [
          { required: true, message: "请选择父级分类", trigger: "change" }
        ],
        categoryName: [
          { required: true, message: "请输入分类名称", trigger: ["blur"] },
          { validator: checkCategoryName, trigger: ["blur"] }
        ]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.renderPageData(val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 重新渲染页面数据
    renderPageData(val) {
      this.dialogForm = JSON.parse(JSON.stringify(val))
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.renderPageData(this.baseForm)
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async valid => {
        if (valid) {
          //更新
          if (this.dialogForm.categoryId) {
            categoryApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑分类成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            categoryApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增分类成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
